import styled from 'styled-components';

import { breakpoint } from 'theme';

const Border = styled.div.attrs({ role: 'separator' })`
  ${breakpoint.down('ltm')`
    padding-left: 1em;
    padding-right: 1em;
  `};

  padding-top: 1.125em;
  padding-bottom: 1.125em;
  border-top: 1px solid ${({ theme }) => theme.transparentColors.nevada20};

  &:last-child {
    border-bottom: 1px solid ${({ theme }) => theme.transparentColors.nevada20};
  }
`;

export default Border;
